import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function NoRisk() {
  return <section className="py-14 bg-cream-50" data-id="element-201">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-charcoal text-cream-50 p-10 md:p-16 text-center relative overflow-hidden" data-id="element-203">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 text-olive-900/50" data-id="element-204">
            <ShieldIcon className="h-64 w-64" strokeWidth={0.5} data-id="element-205" />
          </div>

          <div className="relative z-10" data-id="element-206">
            <ShieldIcon className="h-12 w-12 text-terracotta-400 mx-auto mb-6" strokeWidth={1.5} data-id="element-207" />

            <h2 className="text-2xl md:text-3xl font-display mb-6" data-id="element-208">
              Sin riesgo — porque confiamos en lo que ofrecemos
            </h2>

            <div className="space-y-4 text-lg font-light text-cream-100/80 max-w-2xl mx-auto" data-id="element-209">
              <p data-id="element-210">Sabemos que has comprado ropa antes que te decepcionó.</p>
              <p data-id="element-211">Por eso te invitamos a venir, ver, tocarlo y probarlo.</p>
              <p className="font-medium text-cream-50 text-xl py-2" data-id="element-212">
                Sin presión. Sin compromiso de compra obligatoria.
              </p>
              <p data-id="element-213">
                Solo la experiencia de descubrir qué pasa cuando la ropa está
                hecha para ti — y no al revés.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}